/*
 * Configurador de obra: vista a escala en un espacio real + pasos Tamaño y Marco.
 * Datos: los tres <script type="application/json"> de sections/fr-configurator.liquid.
 * Lógica pura: assets/fr-configurator-core.js (window.FRConfigurator). Animación: GSAP global del tema.
 */
(function () {
  'use strict';

  var FR = window.FRConfigurator;
  if (!FR) { console.error('[fr-configurator] falta fr-configurator-core.js; no se inicia.'); return; }
  var FRAME_CM = 2;             // grosor visible de la moldura
  var PAPER_MARGIN_CM = 1;      // "Solo impresión": borde blanco de papel, igual en todos los tamaños
  var HANG_CENTER_CM = 150;     // centro de la obra en pared libre, estándar de galería
  var MOBILE = '(max-width: 860px)';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'expo.out', QUICK = 0.22, MOVE = 0.55;
  function D(s) { return REDUCED ? 0 : s; }

  // Escenas generadas con IA, todas con la misma calibración. Medidas sobre el original de 2752 px
  // (ceil, cx, box); person ya está en px del mundo (2400).
  var IMG_W = 2400, IMG_H = 1340, K = IMG_W / 2752;
  var PXCM = 4.29 * K;
  var FLOOR_Y = 1299 * K;
  var SCENES = {
    estudio:  { ceil: 143, cx: 1376, minB: 95,  box: [985, 793, 1767, 1376], person: [595, 494, 802, 1219] },
    recamara: { ceil: 143, cx: 1376, minB: 115, box: [702, 881, 2064, 1459], person: [1920, 533, 2107, 1169] },
    comedor:  { ceil: 143, cx: 1376, minB: 105, box: [572, 977, 2188, 1486], person: [1973, 504, 2143, 1193] },
    sala:     { ceil: 184, cx: 1373, minB: 100, box: [733, 970, 2013, 1362], person: [233, 485, 437, 1224] },
    galeria:  { ceil: 143, cx: 1156, minB: 30,  box: [1830, 605, 2070, 1398], person: [1596, 528, 1805, 1219], alwaysPerson: true }
  };
  var FRAMES = [
    { value: FR.NO_FRAME, key: 'solo' },
    { value: 'Madera Negra', key: 'negra' },
    { value: 'Madera Maple', key: 'maple' },
    { value: 'Madera Nogal', key: 'nogal' }
  ];

  function readJson(root, attr) {
    var el = root.parentNode.querySelector('script[' + attr + ']');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    var P = readJson(root, 'data-fr-product');
    var A = readJson(root, 'data-fr-assets');
    var T = readJson(root, 'data-fr-i18n') || {};
    if (!window.gsap || !P || !A || !P.image || !P.variants.length) {
      console.error('[fr-configurator] faltan datos o dependencias; no se inicia.');
      return;
    }
    var gsap = window.gsap;
    var $ = function (sel) { return root.querySelector(sel); };
    var els = {
      stage: $('[data-stage]'), world: $('[data-world]'), bgs: root.querySelectorAll('[data-bg]'),
      art: $('[data-art]'), frame: $('[data-frame]'), artImg: $('[data-art-img]'), light: $('[data-light]'),
      lip: $('[data-lip]'), dimW: $('[data-dim-w]'), dimH: $('[data-dim-h]'), cap: $('[data-cap]'),
      detail: $('[data-detail]'), person: $('[data-person]'), scenes: $('[data-scenes]'), intro: $('[data-intro]'),
      panel: $('[data-panel]'), body: $('[data-step-body]')
    };
    var toastEl = document.createElement('div');
    toastEl.className = 'fr-cfg__toast';
    toastEl.setAttribute('role', 'status');
    toastEl.hidden = true;
    root.appendChild(toastEl);

    var orient = FR.productOrientation(P);
    var sizes = FR.sizesOf(P);
    var money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: P.currency || 'MXN', currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
    function fmt(cents) { return money.format(cents / 100) + ' ' + (P.currency || 'MXN'); }
    function t(key, vars) {
      var s = T[key] || key;
      Object.keys(vars || {}).forEach(function (k) { s = s.replace(new RegExp('{{\\s*' + k + '\\s*}}', 'g'), function () { return String(vars[k]); }); });
      return s;
    }
    function frameOf(value) { return FRAMES.filter(function (f) { return f.value === value; })[0] || FRAMES[0]; }

    var S = { size: null, frame: FR.NO_FRAME, scene: 'sala', sceneManual: false, step: 0, person: true, qty: 1 };
    // Edición limitada desde los metafields; null si el producto aún no los tiene (se oculta el contador).
    var ED = P.edition ? FR.edition(P.edition.total, P.edition.sold) : null;
    var LOW_STOCK = 10;
    var shownPrice = 0, busy = false;
    var cam = { ax: 0, ay: 0, aw: 0, ah: 0, fw: 0, k: 0.4, tx: 0, ty: 0 };
    var bgOn = els.bgs[0];

    // Variante inicial: la del ?variant= si viene en la URL; si no, ~90 × 60 (índice 3) sin marco.
    var fromUrl = new URLSearchParams(location.search).get('variant');
    var start = fromUrl && P.variants.filter(function (v) { return String(v.id) === fromUrl; })[0];
    if (start) {
      S.size = FR.optionValue(P, start, FR.SIZE_OPTION);
      S.frame = FR.optionValue(P, start, FR.FRAME_OPTION) || FR.NO_FRAME;
    } else {
      S.size = sizes[Math.min(3, sizes.length - 1)];
    }

    function withPerson(s) { return S.person || !!SCENES[s].alwaysPerson; }
    function sceneUrl(s) { return A.scenes[s][withPerson(s) ? 'person' : 'plain']; }
    function sizeCm(label) { return FR.sizeCm(orient, label || S.size); }

    // ---------- geometría ----------
    // cm -> caja en px del mundo. Sobre mueble: ~20 cm arriba de él; pared libre: centro a 150 cm.
    function hang(scene, w, h) {
      var sc = SCENES[scene];
      var b = sc.minB >= 60 ? sc.minB : Math.max(sc.minB, HANG_CENTER_CM - h / 2);
      var ceilCm = (FLOOR_Y - sc.ceil * K) / PXCM;
      var x = sc.cx * K - w * PXCM / 2, y = FLOOR_Y - (b + h) * PXCM, pw = w * PXCM, ph = h * PXCM, pb = sc.person;
      var behind = withPerson(scene) && x < pb[2] && x + pw > pb[0] && y < pb[3] && y + ph > pb[1];
      return { x: x, y: y, w: pw, h: ph, fits: b + h <= ceilCm - 4 && !behind };
    }
    function outer() {
      var sz = sizeCm(), fw = S.frame === FR.NO_FRAME ? 0 : FRAME_CM;
      return { w: sz.w + 2 * fw, h: sz.h + 2 * fw, fw: fw };
    }
    function fits(scene) { var o = outer(); return hang(scene, o.w, o.h).fits; }
    function suggest() {
      var sz = sizeCm(), L = Math.max(sz.w, sz.h);
      var order = L <= 45 ? ['estudio', 'recamara', 'sala'] : L <= 60 ? ['recamara', 'comedor', 'sala']
        : L <= 110 ? ['sala', 'comedor', 'recamara'] : ['sala', 'galeria'];
      return order.filter(fits)[0] || 'galeria';
    }
    function target() {
      var st = els.stage.getBoundingClientRect(), o = outer(), a = hang(S.scene, o.w, o.h);
      var sc = SCENES[S.scene], pb = sc.person;
      var bx0 = sc.box.map(function (v) { return v * K; });
      var bx = withPerson(S.scene) ? [Math.min(bx0[0], pb[0]), Math.min(bx0[1], pb[1]), Math.max(bx0[2], pb[2]), Math.max(bx0[3], pb[3])] : bx0;
      var m = Math.max(a.w, a.h) * 0.45 + 40 * PXCM;
      var x0 = Math.min(a.x - m, bx[0] - 20 * PXCM), x1 = Math.max(a.x + a.w + m, bx[2] + 20 * PXCM);
      var y0 = a.y - m * 0.8, y1 = Math.max(bx[3], FLOOR_Y) + 10 * PXCM;
      var kFit = Math.min(st.width / (x1 - x0), st.height / (y1 - y0));
      var kCover = Math.max(st.width / IMG_W, st.height / IMG_H);
      var k = Math.min(Math.max(kFit, kCover), 1.1);   // nunca se ve fuera de la foto ni se pixelea
      // Encuadre horizontal: todo > persona completa + obra > obra y mueble. Nunca una persona cortada.
      var vw = st.width / k, spans = [[x0, x1]];
      if (withPerson(S.scene)) {
        var pad = 15 * PXCM;
        spans.push(pb[0] < a.x ? [pb[0] - pad, a.x + a.w + m * 0.5] : [a.x - m * 0.5, pb[2] + pad]);
      }
      spans.push([Math.min(a.x - m, bx0[0]), Math.max(a.x + a.w + m, bx0[2])]);
      var span = spans.filter(function (s) { return s[1] - s[0] <= vw; })[0] || spans[spans.length - 1];
      var tx = Math.min(0, Math.max(st.width - IMG_W * k, st.width / 2 - (span[0] + span[1]) / 2 * k));
      var ty = Math.min(0, Math.max(st.height - IMG_H * k, st.height / 2 - (y0 + y1) / 2 * k));
      return { ax: a.x, ay: a.y, aw: a.w, ah: a.h, fw: o.fw * PXCM, k: k, tx: tx, ty: ty };
    }
    function render() {
      var c = cam;
      els.world.style.transform = 'translate(' + c.tx + 'px,' + c.ty + 'px) scale(' + c.k + ')';
      Object.assign(els.art.style, {
        left: c.ax + 'px', top: c.ay + 'px', width: c.aw + 'px', height: c.ah + 'px',
        boxShadow: c.fw > 0.5
          ? '12px 14px 20px -6px rgba(45,32,18,.34), 4px 5px 7px rgba(45,32,18,.26), 1px 1px 1px rgba(45,32,18,.35)'
          : '2px 3px 7px rgba(45,32,18,.22), 0 0 0 .5px rgba(0,0,0,.08)'
      });
      Object.assign(els.lip.style, {
        left: c.fw + 'px', top: c.fw + 'px', right: c.fw + 'px', bottom: c.fw + 'px',
        boxShadow: 'inset 5px 6px 7px -3px rgba(0,0,0,.30), inset 0 0 0 1px rgba(0,0,0,.18)'
      });
      els.frame.style.borderWidth = c.fw + 'px';
      // El borde de papel se desvanece mientras entra la moldura (enmarcada va sin paspartú).
      els.frame.style.padding = PAPER_MARGIN_CM * PXCM * Math.max(0, 1 - c.fw / (FRAME_CM * PXCM)) + 'px';
      els.light.style.backgroundPosition = -c.ax + 'px ' + -c.ay + 'px';
      var st = els.stage.getBoundingClientRect(), r = els.art.getBoundingClientRect();
      var L = r.left - st.left, Tp = r.top - st.top;
      Object.assign(els.dimW.style, { left: L + 'px', top: (Tp - 16) + 'px', width: r.width + 'px' });
      Object.assign(els.dimH.style, { left: (L - 16) + 'px', top: Tp + 'px', height: r.height + 'px' });
    }
    function animateScene(dur) {
      gsap.to(cam, Object.assign(target(), { duration: D(dur || MOVE), ease: EASE, onUpdate: render, overwrite: true }));
    }

    // ---------- contenido de la escena ----------
    function caption() {
      return t('scale_caption') + ' · ' + t('scene_' + S.scene);
    }
    function setDims() {
      var sz = sizeCm();
      els.dimW.firstElementChild.textContent = sz.w + ' cm';
      els.dimH.firstElementChild.textContent = sz.h + ' cm';
      gsap.fromTo([els.dimW.firstElementChild, els.dimH.firstElementChild], { opacity: 0, y: 3 }, { opacity: 1, y: 0, duration: D(QUICK), ease: EASE });
    }
    function setFrame() {
      var f = frameOf(S.frame);
      els.frame.style.borderImage = f.key === 'solo' ? 'none' : 'url("' + A.frames[f.key].texture + '") 64 stretch';
      els.art.classList.toggle('is-framed', f.key !== 'solo');
      if (!REDUCED) gsap.fromTo(els.art, { scale: 0.99 }, { scale: 1, duration: 0.35, ease: EASE });
    }
    function setScene(first) {
      var url = sceneUrl(S.scene);
      var next = first ? els.bgs[0] : (bgOn === els.bgs[0] ? els.bgs[1] : els.bgs[0]);
      els.light.style.backgroundImage = 'url("' + url + '")';
      els.light.style.backgroundSize = IMG_W + 'px ' + IMG_H + 'px';
      // La capa visible se decide en el acto; el fundido espera a que la imagen esté decodificada.
      if (first || bgOn.getAttribute('src') !== url) {
        var prev = bgOn;
        bgOn = next;
        if (next.getAttribute('src') !== url) next.src = url;
        var show = function () {
          if (bgOn !== next) return;   // otro cambio llegó antes de terminar de decodificar
          gsap.to(next, { opacity: 1, duration: D(first ? 0 : 0.35), ease: 'power1.out', overwrite: true });
          if (prev !== next) gsap.to(prev, { opacity: 0, duration: D(0.35), delay: D(0.05), overwrite: true });
        };
        next.decode ? next.decode().then(show, show) : show();
      }
      els.cap.textContent = caption();
      els.person.setAttribute('aria-checked', String(withPerson(S.scene)));
      els.person.setAttribute('aria-disabled', String(!!SCENES[S.scene].alwaysPerson));
      els.scenes.querySelectorAll('[data-scene]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.scene === S.scene));
        b.setAttribute('aria-disabled', String(!fits(b.dataset.scene)));
      });
      movePill();
    }
    function movePill() {
      var on = els.scenes.querySelector('[aria-pressed="true"]');
      if (on) gsap.to(els.scenes.querySelector('.fr-cfg__pill'), { left: on.offsetLeft, width: on.offsetWidth, duration: D(0.35), ease: EASE });
    }
    // Contorno del tamaño anterior; solo compara si la pared es la misma.
    function ghost(prevScene, label) {
      if (prevScene !== S.scene || REDUCED) return;
      var g = document.createElement('div');
      g.className = 'fr-cfg__ghost';
      Object.assign(g.style, { left: cam.ax + 'px', top: cam.ay + 'px', width: cam.aw + 'px', height: cam.ah + 'px', borderWidth: (1.5 / cam.k) + 'px' });
      var span = document.createElement('span');
      span.style.fontSize = (11 / cam.k) + 'px';
      span.textContent = t('before') + ' ' + label;
      g.appendChild(span);
      els.world.appendChild(g);
      gsap.to(g, { opacity: 0, duration: 0.9, delay: 0.35, ease: 'power2.in', onComplete: function () { g.remove(); } });
    }
    function sizeChanged() {
      var before = S.scene;
      if (!S.sceneManual || !fits(S.scene)) S.scene = suggest();
      if (S.sceneManual && before !== S.scene) {
        toast(t('moved', { from: t('scene_' + before).toLowerCase(), to: t('scene_' + S.scene).toLowerCase() }));
      }
      setScene();
    }

    // ---------- panel ----------
    // Los pasos viven en la columna como títulos "Paso N: …"; "Paso anterior" está en la barra de abajo.
    var STEP_TITLES = ['step_title_size', 'step_title_frame', 'step_title_summary'];
    function stepTitle(i, aside) {
      return '<div class="fr-cfg__section-title"><h2 tabindex="-1">' + esc(t(STEP_TITLES[i])) + '</h2>' + (aside || '') + '</div>';
    }
    function tilesSize() {
      return stepTitle(0) +
        '<p class="fr-cfg__hint">' + esc(t('size_hint')) + '</p>' +
        '<div class="fr-cfg__tiles" role="radiogroup" aria-label="' + esc(t('step_size')) + '">' +
        sizes.map(function (v) {
          var sz = sizeCm(v);
          // El paso 1 muestra el precio de solo impresión (aunque se llegue con ?variant= de una variante con marco).
          var price = FR.priceOf(P, v, FR.NO_FRAME);
          if (price === null) price = FR.priceOf(P, v, S.frame);
          return '<button type="button" class="fr-cfg__tile fr-cfg__tile--compact" role="radio" data-size="' + esc(v) + '" aria-checked="' + (v === S.size) + '" tabindex="' + (v === S.size ? 0 : -1) + '"' + (price === null ? ' aria-disabled="true"' : '') + '>' +
            '<span class="fr-cfg__t1 fr-num">' + sz.w + ' × ' + sz.h + ' cm</span>' +
            '<span class="fr-cfg__t2">' + esc(t('print_only')) + '</span>' +
            '<span class="fr-cfg__t3 fr-num">' + (price === null ? '—' : fmt(price)) + '</span></button>';
        }).join('') + '</div>';
    }
    function tilesFrame() {
      var sz = sizeCm();
      var frames = FRAMES.filter(function (f) { return FR.findVariant(P, S.size, f.value); });
      return stepTitle(1) +
        '<p class="fr-cfg__hint">' + esc(t('frame_hint')) + '</p>' +
        '<div class="fr-cfg__pick"><span class="fr-eyebrow">' + esc(t('your_pick')) + '</span>' +
          '<span class="fr-num">' + sz.w + ' × ' + sz.h + ' cm · ' + esc(t('frame_' + frameOf(S.frame).key)) + '</span>' +
          '<b class="fr-num">' + fmt(variant().price) + '</b></div>' +
        '<div class="fr-cfg__tiles" role="radiogroup" aria-label="' + esc(t('step_frame')) + '">' +
        frames.map(function (f) {
          // Esquina del marco real (la misma textura del muro) sobre la foto de la obra.
          var art = A.art ? 'background-image:url(&quot;' + esc(A.art) + '&quot;);' : '';
          var tex = f.key === 'solo' ? '' : 'border-image-source:url(&quot;' + esc(A.frames[f.key].texture) + '&quot;);';
          var sw = '<span class="fr-cfg__corner' + (f.key === 'solo' ? ' is-solo' : '') + '" aria-hidden="true"><span style="' + art + tex + '"></span></span>';
          return '<button type="button" class="fr-cfg__tile" role="radio" data-frame="' + esc(f.value) + '" aria-checked="' + (f.value === S.frame) + '" tabindex="' + (f.value === S.frame ? 0 : -1) + '">' + sw +
            '<span class="fr-cfg__t1">' + esc(t('frame_' + f.key)) + '</span>' +
            '<span class="fr-cfg__t3 fr-num">' + fmt(FR.priceOf(P, S.size, f.value)) + '</span></button>';
        }).join('') + '</div>';
    }
    // ---------- resumen, edición y barra ----------
    function variant() { return FR.findVariant(P, S.size, S.frame); }
    function soldOut() { var v = variant(); return (ED && ED.out) || !v || !v.available; }
    function soldOutLabel() { return ED && ED.out ? t('sold_out') : t('unavailable'); }
    function numbers() { return FR.editionNumbers(ED.sold, S.qty); }
    function recap() {
      var sz = sizeCm(), v = variant(), f = frameOf(S.frame), out = soldOut();
      var row = function (dt, dd) { return '<dt>' + esc(dt) + '</dt><dd>' + dd + '</dd>'; };
      var edit = function (step) { return '<button type="button" class="fr-cfg__edit" data-go="' + step + '">' + esc(t('edit')) + '</button>'; };
      return '<div class="fr-cfg__recap">' + stepTitle(2, ED ? '<span class="fr-eyebrow">' + esc(t('edition_of', { total: ED.total })) + '</span>' : '') + '<dl>' +
        row(t('artwork'), esc(P.title)) +
        (P.artist ? row(t('photographer'), esc(P.artist)) : '') +
        (P.year ? row(t('year'), '<span class="fr-num">' + esc(P.year) + '</span>') : '') +
        row(t('step_size'), '<span class="fr-num">' + sz.w + ' × ' + sz.h + ' cm</span>' + edit(0)) +
        row(t('step_frame'), esc(t('frame_' + f.key)) + edit(1)) +
        row(t('unit_price'), '<span class="fr-num">' + fmt(v.price) + '</span>') +
        (out ? '' : row(t('quantity'), '<span class="fr-cfg__qty"><button type="button" data-q="-1" aria-label="' + esc(t('less')) + '">−</button>' +
          '<span class="fr-num" data-qty aria-live="polite">' + S.qty + '</span><button type="button" data-q="1" aria-label="' + esc(t('more')) + '">+</button></span>')) +
        '</dl><div class="fr-cfg__total"><span>' + esc(t('total')) + '</span><span class="fr-cfg__big fr-num" data-total>' + fmt(v.price * S.qty) + '</span></div>' +
        (ED && !out ? '<div class="fr-cfg__ejemplar"><div><span class="fr-eyebrow">' + esc(t(S.qty > 1 ? 'your_copies' : 'your_copy')) + '</span><small>' + esc(t('number_note')) + '</small></div>' +
          '<div class="fr-cfg__no fr-num" data-no>Nº ' + numbers() + '<span> / ' + ED.total + '</span></div></div>' : '') +
        '</div><div class="fr-cfg__cta">' + (out
          ? '<button type="button" class="fr-cfg__btn" disabled>' + esc(soldOutLabel()) + '</button>'
          : '<button type="button" class="fr-cfg__btn fr-cfg__btn--primary" data-cta="cart">' + esc(t('add_to_cart')) + '</button>' +
            '<button type="button" class="fr-cfg__btn fr-cfg__btn--ghost" data-cta="buy">' + esc(t('buy_now')) + '</button>') + '</div>';
    }
    function renderEdition() {
      var el = $('[data-edition]');
      if (!ED) return;
      var note = ED.out ? esc(t('sold_out_all', { total: ED.total }))
        : ED.left <= LOW_STOCK ? '<span class="fr-cfg__low">' + esc(t('last_left', { left: ED.left })) + '</span> · ' + esc(t('sold_count', { sold: ED.sold }))
        : esc(t('sold_count', { sold: ED.sold }) + ' · ' + t('signed'));
      el.classList.toggle('is-out', ED.out);
      el.innerHTML = '<div class="fr-cfg__ed-top"><span class="fr-eyebrow">' + esc(t('edition_of', { total: ED.total })) + '</span>' +
        '<b class="fr-num">' + esc(ED.out ? t('sold_out') : t('available', { left: ED.left })) + '</b></div>' +
        '<div class="fr-cfg__ed-bar" aria-hidden="true"><i></i></div><div class="fr-cfg__ed-note fr-num">' + note + '</div>';
      el.hidden = false;
      gsap.fromTo(el.querySelector('i'), { width: '0%' }, { width: (ED.sold / ED.total * 100) + '%', duration: D(0.9), ease: EASE, delay: D(0.2) });
    }
    function renderBar() {
      var sz = sizeCm(), v = variant(), f = frameOf(S.frame), last = S.step === 2;
      var price = v.price * (last ? S.qty : 1);
      var chip = function (txt, num) { return '<span class="fr-cfg__chip-s' + (num ? ' fr-num' : '') + '">' + esc(txt) + '</span>'; };
      root.querySelector('[data-chips]').innerHTML = chip(P.title) + chip(sz.w + ' × ' + sz.h + ' cm', true) + chip(t('frame_' + f.key)) +
        (ED ? chip(ED.out ? t('sold_out') : 'Nº ' + numbers() + '/' + ED.total, true) : '');
      root.querySelector('[data-bar-label]').textContent = last && S.qty > 1 ? t('total_pieces', { qty: S.qty }) : t('total');
      root.querySelector('[data-bar-prev]').hidden = S.step === 0;
      var btn = root.querySelector('[data-bar-btn]');
      btn.textContent = last && soldOut() ? soldOutLabel() : busy ? t('adding') : [t('next_frame'), t('next_summary'), t('add_to_cart')][S.step];
      btn.disabled = busy || (last && soldOut());
      var priceEl = root.querySelector('[data-bar-price]'), o = { n: shownPrice };
      gsap.to(o, { n: price, duration: D(0.35), ease: EASE, overwrite: true, onUpdate: function () { priceEl.textContent = fmt(Math.round(o.n)); } });
      shownPrice = price;
    }
    function publish(name) {
      var v = variant();
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          Shopify.analytics.publish(name, { product_handle: P.handle, variant_id: v.id, size: S.size, frame: S.frame, quantity: S.qty, price: v.price / 100, currency: P.currency });
        }
      } catch (e) { console.error('[fr-configurator] analytics', e); }
    }
    // Cada cambio de variante deja su propia URL (?variant=) para anuncios y para compartir, y avisa a los pixels.
    function variantChanged() {
      var v = variant(), u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u);
      S.qty = Math.min(S.qty, Math.max(1, FR.maxQty(ED ? ED.left : null)));
      renderBar();
      publish('fr_configurator_option');
    }
    function setQty(delta) {
      var max = FR.maxQty(ED ? ED.left : null), want = S.qty + delta;
      if (want > max && delta > 0) toast(ED && ED.left <= LOW_STOCK ? t('only_left', { left: ED.left }) : t('max_qty', { max: max }));
      S.qty = Math.min(max, Math.max(1, want));
      root.querySelector('[data-qty]').textContent = S.qty;
      root.querySelector('[data-total]').textContent = fmt(variant().price * S.qty);
      var no = root.querySelector('[data-no]');
      if (no) {
        no.firstChild.textContent = 'Nº ' + numbers();
        no.parentNode.querySelector('.fr-eyebrow').textContent = t(S.qty > 1 ? 'your_copies' : 'your_copy');
        gsap.fromTo(no, { y: -4, opacity: 0.3 }, { y: 0, opacity: 1, duration: D(0.3), ease: EASE });
      }
      renderBar();
    }

    // ---------- carrito ----------
    function cartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    function setBusy(on) {
      busy = on;
      els.body.querySelectorAll('[data-cta]').forEach(function (b) { b.disabled = on; });
      renderBar();
    }
    // El cajón del carrito lo arma Liquid: se vuelve a pedir la sección del navbar (Section Rendering API)
    // y se reemplaza solo su contenido. Si falla, al menos se actualizan los números con /cart.js.
    function refreshCart() {
      var host = document.querySelector('[id^="shopify-section-"][id$="default-navigation"]');
      var drawerOf = function (doc) { var f = doc.querySelector('[data-cart-form]'); return f && f.closest('.navbar-dropdown-side-drawer-content'); };
      var drawer = drawerOf(document);
      var fallback = function () {
        return fetch(cartRoot() + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          if (typeof window.updateCartUI === 'function') window.updateCartUI(cart);
        });
      };
      if (!host || !drawer) return fallback();
      var id = host.id.replace('shopify-section-', '');
      return fetch(location.pathname + '?sections=' + encodeURIComponent(id))
        .then(function (r) { if (!r.ok) throw new Error('sections ' + r.status); return r.json(); })
        .then(function (json) {
          var doc = new DOMParser().parseFromString(json[id] || '', 'text/html');
          var fresh = drawerOf(doc);
          var badge = doc.querySelector('.navbar-cart-number-wrapper'), oldBadge = document.querySelector('.navbar-cart-number-wrapper');
          if (!fresh) throw new Error('sin cajón en la respuesta');
          drawer.innerHTML = fresh.innerHTML;
          if (badge && oldBadge) oldBadge.replaceWith(badge);
        })
        .catch(function (err) { console.error('[fr-configurator] cajón', err); return fallback(); });
    }
    function openCart() {
      var toggle = document.querySelector('.w-dropdown-toggle.is-cart');
      // El dropdown de Webflow escucha mouseup, no click.
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.dispatchEvent(new MouseEvent('mouseup', { bubbles: true }));
    }
    function addToCart(kind) {
      var v = variant();
      if (busy || soldOut()) return;
      setBusy(true);
      var leaving = false;
      // La edición es una sola para todos los tamaños y marcos: lo que ya está en el carrito cuenta contra lo que queda.
      // ponytail: control del lado del cliente; el candado real es el inventario que Flow pone en 0 al agotarse (etapa E).
      var checkEdition = !ED ? Promise.resolve() : fetch(cartRoot() + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var inCart = (cart.items || []).reduce(function (n, i) { return n + (i.handle === P.handle ? i.quantity : 0); }, 0);
        if (inCart + S.qty > ED.left) throw new Error(t('only_left', { left: ED.left }));
      });
      checkEdition.then(function () { return fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: S.qty }] })
      }); })
        .then(function (r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            // Shopify responde 422 con un texto legible (p. ej., sin inventario suficiente).
            if (!r.ok) throw new Error(body.description || body.message || '');
            return body;
          });
        })
        .then(function () {
          publish('fr_configurator_add');
          if (kind === 'buy') { leaving = true; location.href = cartRoot() + 'checkout'; return; }
          return refreshCart().then(function () { toast(t('added')); openCart(); });
        })
        .catch(function (err) {
          console.error('[fr-configurator] carrito', err);
          toast(err.message || t('cart_error'));
        })
        .then(function () { if (!leaving) setBusy(false); });
    }

    // En celular las opciones son un carrusel: la elegida se centra cada vez que se pinta el panel.
    function centerPicked() {
      if (!window.matchMedia(MOBILE).matches) return;
      var on = els.body.querySelector('.fr-cfg__tiles [aria-checked="true"]');
      if (!on) return;
      var row = on.parentNode;
      row.scrollLeft = on.offsetLeft - (row.clientWidth - on.offsetWidth) / 2;
    }
    function renderPanel(animate) {
      els.body.innerHTML = [tilesSize, tilesFrame, recap][S.step]();
      requestAnimationFrame(centerPicked);
      if (animate && !REDUCED) {
        gsap.from(els.body.querySelectorAll('.fr-cfg__tile, .fr-cfg__section-title, .fr-cfg__hint, .fr-cfg__recap dt, .fr-cfg__recap dd, .fr-cfg__total, .fr-cfg__cta'),
          { opacity: 0, y: 6, duration: 0.32, stagger: 0.012, ease: EASE });
      }
    }
    // Re-render conservando el foco del teclado en la opción elegida.
    function rerenderKeepFocus(attr, value) {
      var hadFocus = els.body.contains(document.activeElement);
      renderPanel(false);
      if (!hadFocus) return;
      var btn = els.body.querySelector('[' + attr + '="' + CSS.escape(value) + '"]');
      if (btn) btn.focus();
    }
    function setStep(i, scroll) {
      S.step = i;
      // El paso 1 es solo impresión: al regresar se quita el marco elegido.
      if (i === 0 && S.frame !== FR.NO_FRAME && FR.findVariant(P, S.size, FR.NO_FRAME)) {
        S.frame = FR.NO_FRAME;
        setFrame(); setScene(); animateScene(0.4);
        variantChanged();
      }
      renderPanel(true);
      renderBar();
      // El panel se vuelve a pintar: el foco pasa al título del paso para no perderse en <body>.
      if (scroll) { var h = els.body.querySelector('h2'); if (h) h.focus({ preventScroll: true }); }
      // Al cambiar de paso, el inicio de las opciones vuelve a la vista si quedó arriba (en celular, siempre).
      var stuck = els.panel.getBoundingClientRect().top < els.stage.getBoundingClientRect().top - 1;
      // En celular el configurador cabe en una pantalla: se regresa a su inicio y el panel a su primera línea.
      if (scroll && window.matchMedia(MOBILE).matches) {
        els.panel.scrollTop = 0;
        if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
      } else if (scroll && stuck) els.panel.scrollIntoView({ block: 'start', behavior: REDUCED ? 'auto' : 'smooth' });
    }
    function toast(msg) {
      toastEl.textContent = msg;
      toastEl.hidden = false;
      gsap.fromTo(toastEl, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: D(0.3) });
      clearTimeout(toast.timer);
      toast.timer = setTimeout(function () {
        gsap.to(toastEl, { opacity: 0, duration: D(0.3), onComplete: function () { toastEl.hidden = true; } });
      }, 3200);
    }

    // ---------- entrada: la foto crece desde todo el cuadro hasta su lugar en la pared ----------
    function intro() {
      if (REDUCED || !els.artImg) return;
      var st = els.stage.getBoundingClientRect(), pr = els.artImg.getBoundingClientRect();
      els.intro.src = els.artImg.currentSrc || els.artImg.src;
      els.intro.hidden = false;
      gsap.set(els.intro, { left: 0, top: 0, width: st.width, height: st.height, opacity: 1 });
      gsap.set([els.art, els.dimW, els.dimH, els.cap], { opacity: 0 });
      gsap.timeline({ defaults: { ease: 'expo.inOut' } })
        .to(els.intro, { left: pr.left - st.left, top: pr.top - st.top, width: pr.width, height: pr.height, duration: 0.8, delay: 0.1 })
        .to(els.art, { opacity: 1, duration: 0.2 }, '-=.12')
        .to(els.intro, { opacity: 0, duration: 0.2, onComplete: function () { els.intro.hidden = true; } }, '<')
        .to([els.dimW, els.dimH, els.cap], { opacity: 1, duration: 0.25, ease: EASE }, '<.08');
    }

    // Entrada del resto de la interfaz, coordinada con la de la foto: controles, cabecera y barra.
    function enter() {
      if (REDUCED) return;
      var d = { duration: 0.6, ease: EASE, clearProps: 'transform,opacity' };
      gsap.from([root.querySelector('.fr-cfg__tools-top'), els.scenes], Object.assign({ opacity: 0, y: 8, stagger: 0.08, delay: 0.35 }, d));
      gsap.from(root.querySelectorAll('.fr-cfg__head > *:not([hidden])'), Object.assign({ opacity: 0, y: 12, stagger: 0.06, delay: 0.1 }, d));
      gsap.from(root.querySelector('[data-bar]'), Object.assign({ yPercent: 100, delay: 0.3 }, d, { duration: 0.7 }));
    }

    // Si se llegó desde la obra con transición de vista, la foto ya viajó: no se repite la entrada.
    function startIntro() {
      if (!('onpagereveal' in window)) { intro(); return; }
      if (window.__frReveal) { if (window.__frReveal !== 'vt') intro(); return; }
      // El listener de <head> corre primero y decide si la transición se canceló.
      window.addEventListener('pagereveal', function () { if (window.__frReveal !== 'vt') intro(); }, { once: true });
    }

    // ---------- eventos ----------
    els.body.addEventListener('click', function (e) {
      var act = e.target.closest('[data-q],[data-go],[data-cta]');
      if (act) {
        if (act.dataset.q) setQty(+act.dataset.q);
        else if (act.dataset.go) setStep(+act.dataset.go, true);
        else addToCart(act.dataset.cta);
        return;
      }
      var tile = e.target.closest('[data-size],[data-frame]');
      if (!tile || tile.getAttribute('aria-disabled') === 'true') return;
      if (tile.dataset.size) {
        if (tile.dataset.size === S.size) return;
        var prev = sizeCm(), prevScene = S.scene;
        S.size = tile.dataset.size;
        if (!FR.findVariant(P, S.size, S.frame)) S.frame = FR.NO_FRAME;
        rerenderKeepFocus('data-size', S.size); setDims(); setFrame(); sizeChanged();
        ghost(prevScene, prev.w + ' × ' + prev.h);
        animateScene();
        variantChanged();
      } else {
        if (tile.dataset.frame === S.frame) return;
        S.frame = tile.dataset.frame;
        rerenderKeepFocus('data-frame', S.frame); setFrame(); setScene(); animateScene(0.4);
        variantChanged();
      }
    });
    // Flechas dentro de cada grupo de opciones (patrón radiogroup).
    els.body.addEventListener('keydown', function (e) {
      var d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      var tile = d && e.target.closest('[role="radio"]');
      if (!tile) return;
      var list = [].slice.call(tile.parentNode.querySelectorAll('[role="radio"]:not([aria-disabled="true"])'));
      var next = list[(list.indexOf(tile) + d + list.length) % list.length];
      e.preventDefault();
      if (next && next !== tile) next.click();
    });
    root.querySelector('[data-bar-prev]').addEventListener('click', function () { setStep(S.step - 1, true); });
    root.querySelector('[data-bar-btn]').addEventListener('click', function () {
      if (S.step < 2) setStep(S.step + 1, true); else addToCart('cart');
    });
    els.scenes.addEventListener('click', function (e) {
      var b = e.target.closest('[data-scene]');
      if (!b || b.dataset.scene === S.scene) return;
      if (!fits(b.dataset.scene)) { var sz = sizeCm(); toast(t('doesnt_fit', { size: sz.w + ' × ' + sz.h + ' cm' })); return; }
      S.scene = b.dataset.scene;
      S.sceneManual = true;
      setScene(); animateScene();
    });
    // ---------- foto completa ("Ver detalle" o tocar la obra) ----------
    // <dialog> nativo. Tocar la foto la amplía; el zoom es un
    // contenedor con scroll, así que en celular se recorre arrastrando (scroll nativo) y en desktop siguiendo el mouse.
    var lb = root.querySelector('[data-lb]');   // no existe si el producto no tiene foto
    var lbScroll = lb && lb.querySelector('[data-lb-scroll]'), lbImg = lb && lb.querySelector('[data-lb-img]');
    var LB_ZOOM = 2.5;   // ponytail: zoom fijo de un toque; pellizco libre si lo piden
    function lbZoom(on, e) {
      if (!on) { lb.classList.remove('is-zoomed'); lbImg.style.width = ''; return; }
      var r = lbImg.getBoundingClientRect();
      var w = Math.min(r.width * LB_ZOOM, Math.max(lbImg.naturalWidth, r.width * 1.5));
      lb.classList.add('is-zoomed');
      lbImg.style.width = w + 'px';
      if (e.pointerType === 'mouse') { lbPan(e); return; }   // mismo mapeo que al mover el mouse: sin salto
      lbScroll.scrollLeft = (e.clientX - r.left) / r.width * w - lbScroll.clientWidth / 2;
      lbScroll.scrollTop = (e.clientY - r.top) / r.height * (w * r.height / r.width) - lbScroll.clientHeight / 2;
    }
    function lbPan(e) {
      lbScroll.scrollLeft = e.clientX / lbScroll.clientWidth * (lbScroll.scrollWidth - lbScroll.clientWidth);
      lbScroll.scrollTop = e.clientY / lbScroll.clientHeight * (lbScroll.scrollHeight - lbScroll.clientHeight);
    }
    // Animación: la foto sale de la obra en la pared y regresa a ella al cerrar; el fondo se funde.
    var lbFade = function () { return lb.querySelectorAll('.fr-lb__cap, .fr-lb__close'); };
    function flyFrom() {   // transform que lleva la foto del lightbox encima de la obra
      var a = els.artImg.getBoundingClientRect(), b = lbImg.getBoundingClientRect();
      return { x: a.left + a.width / 2 - (b.left + b.width / 2), y: a.top + a.height / 2 - (b.top + b.height / 2), scale: a.width / b.width };
    }
    function openLightbox() {
      if (!lbImg.src) {
        // Primero la versión que ya cargó la pared (sin cuadro vacío durante la animación); luego la de 3200 px.
        lbImg.src = els.artImg.currentSrc || lbImg.dataset.src;
        var big = new Image();
        big.onload = function () { lbImg.src = big.src; };
        big.src = lbImg.dataset.src;
      }
      lb.showModal();
      gsap.fromTo(lb, { backgroundColor: 'rgba(21,21,20,0)' }, { backgroundColor: 'rgba(21,21,20,1)', duration: D(0.45), ease: 'power2.out' });
      gsap.fromTo(lbImg, flyFrom(), { x: 0, y: 0, scale: 1, duration: D(0.6), ease: EASE, clearProps: 'transform' });
      gsap.fromTo(lbFade(), { opacity: 0 }, { opacity: 1, duration: D(0.3), delay: D(0.3) });
    }
    function closeLightbox() {
      if (!lb.open || lb.classList.contains('is-closing')) return;
      lbZoom(false);
      lb.classList.add('is-closing');
      gsap.to(lbFade(), { opacity: 0, duration: D(0.15) });
      gsap.to(lb, { backgroundColor: 'rgba(21,21,20,0)', duration: D(0.4), ease: 'power2.in' });
      gsap.to(lbImg, Object.assign(flyFrom(), { duration: D(0.45), ease: 'power3.inOut', onComplete: function () {
        lb.close();
        lb.classList.remove('is-closing');
        gsap.set(lbImg, { clearProps: 'transform' });   // no 'all': borraría el --ar del style
        gsap.set(lb, { clearProps: 'backgroundColor' });
        gsap.set(lbFade(), { clearProps: 'opacity' });
      } }));
    }
    if (lb) {
      els.detail.addEventListener('click', openLightbox);
      els.art.addEventListener('click', openLightbox);
      lb.addEventListener('close', function () { lbZoom(false); });
      // Esc (y el atrás de Android) disparan cancel: se cierra con la animación en vez de golpe.
      lb.addEventListener('cancel', function (e) { e.preventDefault(); closeLightbox(); });
      lb.querySelector('[data-lb-close]').addEventListener('click', closeLightbox);
      lbScroll.addEventListener('click', function (e) {
        if (lb.classList.contains('is-closing')) return;
        if (e.target !== lbImg) closeLightbox();
        else lbZoom(!lb.classList.contains('is-zoomed'), e);
      });
      lbScroll.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'mouse' && lb.classList.contains('is-zoomed')) lbPan(e);
      });
    }
    els.person.addEventListener('click', function () {
      if (SCENES[S.scene].alwaysPerson) return;
      S.person = !S.person;
      if (!fits(S.scene)) S.scene = suggest();
      setScene(); animateScene();
    });

    // El navbar de Webflow es fixed: se deja su altura como padding superior.
    function measureNav() {
      var nav = document.querySelector('.navbar');
      if (nav) root.style.setProperty('--fr-nav-h', nav.offsetHeight + 'px');
    }
    new ResizeObserver(function () {
      gsap.killTweensOf(cam);
      Object.assign(cam, target());
      render(); movePill();
    }).observe(els.stage);
    window.addEventListener('resize', measureNav);
    // La barra de anuncios de Webflow también es fixed abajo: la barra del configurador se sienta encima.
    var ann = document.querySelector('[fr-announcement-bar]'), bar = root.querySelector('[data-bar]');
    function measureBottom() {
      var h = 0;
      if (ann) { var r = ann.getBoundingClientRect(); if (r.height && Math.abs(r.bottom - window.innerHeight) < 2) h = r.height; }
      root.style.setProperty('--fr-ann-h', h + 'px');
      root.style.setProperty('--fr-bar-h', bar.offsetHeight + 'px');
    }
    var bottomObserver = new ResizeObserver(measureBottom);
    bottomObserver.observe(bar);
    if (ann) bottomObserver.observe(ann);
    window.addEventListener('resize', measureBottom);

    // ---------- arranque ----------
    measureNav();
    S.scene = suggest();
    renderEdition();
    setFrame(); setDims(); setScene(true); setStep(0, false);
    measureBottom();
    Object.assign(cam, target());
    render();
    window.__frReady = true;   // la transición de vista ya puede aterrizar en la pared (layout/theme.liquid)
    enter();
    startIntro();
    // Las demás escenas se precargan cuando el navegador está libre.
    (window.requestIdleCallback || setTimeout)(function () {
      Object.keys(A.scenes).forEach(function (s) { new Image().src = A.scenes[s].plain; new Image().src = A.scenes[s].person; });
    });
  }

  function boot() { document.querySelectorAll('[data-fr-configurator]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
